import { updateVideoBrief_updateStructuredBrief_fields_SmartShootVideoFields as VideoBriefFields } from '__generated__/updateVideoBrief';
import Text from 'common/components/Text';
import TextArea from 'common/components/TextArea';
import TextList from 'common/components/TextList';
import { ObservableForm, Observe } from 'projects/components/ObservableForm';
import BriefStep from 'projects/components/SmartShoot/BriefStep';
import BriefStepField from 'projects/components/SmartShoot/BriefStepField';
import React from 'react';

interface Props {
    form: ObservableForm<VideoBriefFields>;
    step: number;
}

const ProjectDetailsForm: React.FunctionComponent<Props> = props => (
    <BriefStep
        step={props.step}
        heading="Your project details"
        subheading="Let's start with the basics"
        briefType="video"
    >
        <Observe
            form={props.form}
            name="title"
            render={() => (
                <BriefStepField
                    label="What's the name of your video?"
                    description="Give your video a name so you can find it in your projects."
                    required
                    errorMessage={props.form.getError('title')}
                >
                    <Text
                        placeholder="eg. Facebook promo for Bilbo’s Bakery at The Shire..."
                        maxLength={80}
                        fill
                        {...props.form.attach('title')}
                    />
                </BriefStepField>
            )}
        />

        <Observe
            form={props.form}
            name="description"
            render={() => (
                <BriefStepField
                    label="What's your video about?"
                    description="Tell us all about your video: the purpose, audience, story, look & style and any ideas you have. Include whatever you think will help your filmmaker understand your vision, goals or the problem you’re solving. The more details, the better!"
                    required
                    errorMessage={props.form.getError('description')}
                >
                    <TextArea
                        placeholder="Tell us all about your video..."
                        maxLength={1000}
                        fill
                        {...props.form.attach('description')}
                    />
                </BriefStepField>
            )}
        />

        <Observe
            form={props.form}
            name="inspirationUrls"
            render={() => (
                <BriefStepField
                    label="What will inspire your filmmaker?"
                    description="Help your filmmaker get to know you, your product and your brand with links to your website, social media and branding materials (through a file-sharing link like Dropbox or Google Drive)."
                    errorMessage={props.form.getError('inspirationUrls')}
                >
                    <TextList
                        placeholder="Add links..."
                        fill
                        {...props.form.attach('inspirationUrls')}
                    />
                </BriefStepField>
            )}
        />

        <Observe
            form={props.form}
            name="postVideoCta"
            render={() => (
                <BriefStepField
                    label="What do you want viewers to do after seeing your video?"
                    description="If you’re running a promotion or campaign, include a call to action or message to communicate."
                    errorMessage={(props.form as ObservableForm<VideoBriefFields>).getError(
                        'postVideoCta'
                    )}
                >
                    <Text
                        placeholder="Add a call to action..."
                        maxLength={100}
                        fill
                        {...(props.form as ObservableForm<VideoBriefFields>).attach('postVideoCta')}
                    />
                </BriefStepField>
            )}
        />
    </BriefStep>
);

export default ProjectDetailsForm;
